module.exports = __webpack_public_path__ + "img/Forget-3.ce6c6217.svg";